import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { flatObject } from '../../utils/flat';
import {useCookies} from 'react-cookie';
import IndicatorChart from '../../components/chart/IndicatorChart';
import TrackmanLegendChart from '../../components/chart/TrackmanLegendChart';
import dateSetting from '../../utils/dateSetting';
import ballImage from '../../assets/img/icon/ball_icon.png';
import _ from 'lodash';
import statFormat from '../../utils/stat/statFormat';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';

function TrackmanChartMain({profile, leagueType = 4201}) {
    const [cookies] = useCookies(['hiball_token']);
    let [trackmanData, setTrackmanData] = useState({allStarString: 'before'});
    let {playerId, type} = profile;
    let dateObj = dateSetting();
    let [season, setSeason] = useState(dateObj['selectboxSeason']);
    let todaySeason = (new Date()).getFullYear();
    const { t } = useTranslation();
    const allStarValue = {
        before : {all: 50, batting: 25},
        after: {all: 100, batting: 50}
    };
    const svgHeight = 45;

    useEffect(() => {
        let params = {};
        if(type === 'batter') {
            params = {
                recordType: 'digestRecord', recordName: 'selectRankInfo',
                batterIds: playerId,
                seasons: season,
                gameTypeCode: leagueType,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        } else {
            params = {
                recordType: 'digestRecord', recordName: 'selectRankInfo',
                pitcherIds: playerId,
                seasons: season,
                gameTypeCode: leagueType,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        }

        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params
        }).then((result) => {
            let innerSeason = season ? season : dateObj['season'];
            let rankInfoData = result['data']['result'];
            let indexedRankInfo = _.keyBy(rankInfoData, (item, idx) => item['season']+"_"+item['player_type']);
            let playerData = flatObject(indexedRankInfo[innerSeason+"_"+type]);
            let calcData = statFormat(playerData);
            calcData['allStarString'] = dateObj['allStarString'];
            setTrackmanData(calcData)
        })
    }, [season]);

    function seasonHandler(event) {
        let value = event.target.value;
        setSeason(value);
    }

    const style = {
        display: 'flex', alignItems: 'center'
    }

    return (
        <>
        <div style={{position:'absolute', top: '7px', left: '7px'}}>
            <Form.Group onChange={seasonHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                    <option value={todaySeason-2}>{todaySeason-2}</option>
                    <option value={todaySeason-1}>{todaySeason-1}</option>
                    <option value={todaySeason}>{todaySeason}</option>
                </Form.Select>
            </Form.Group>
        </div>
        <div className="boxTitle"><img src={ballImage} style={{height:'25px'}} /> {t('kboRanking')}(T)</div>
        <div>
            {   
            type === 'batter' ?
                <>
                <div className="trackmanTitle">{t('overall')}</div>
                {
                    trackmanData['tpa'] > allStarValue[trackmanData['allStarString']]['all'] ?
                    <div className="trackmanChart">
                        <div><IndicatorChart data={trackmanData['ops_rank_pct']} 
                        realData={trackmanData['ops']} title={'OPS'} type={type}/></div>
                        <div><IndicatorChart data={trackmanData['xba_rank_pct']} 
                        realData={trackmanData['xba_avg']} title={'xba'} type={type}/></div>
                        <div><IndicatorChart data={trackmanData['xwoba_rank_pct']} 
                        realData={trackmanData['xwoba_avg']} title={'xwoba'} type={type}/></div>
                    </div>
                    :
                    <div className="trackmanChart" style={{height:svgHeight+'px'}}>
                        <div style={style}>타석이 부족합니다</div>
                    </div>
                }
                <div className="trackmanTitle">{t('battedBalls2')}</div>
                {
                    trackmanData['tpa'] > allStarValue[trackmanData['allStarString']]['batting'] ?
                    <>
                        <div className="trackmanChart">
                            <div><IndicatorChart data={trackmanData['exit_speed_rank_pct']} 
                            realData={trackmanData['exit_speed_avg']} title={'avgExitVelocity'} type={type}/></div>
                            <div><IndicatorChart data={trackmanData['max_speed_rank_pct']} 
                            realData={trackmanData['max_speed']} title={'maxExitVelocity'} type={type}/></div>
                            <div><IndicatorChart data={trackmanData['slg_rank_pct']} 
                            realData={trackmanData['slg_pct']} title={'extraBases/hits%'} type={type}/></div>
                        </div>
                        <div className="trackmanChart">
                            <div><IndicatorChart data={trackmanData['strong_hit_rank_pct']} 
                            realData={trackmanData['strong_hit_pct']} title={'hardHit%'} type={type}/></div>
                            <div><IndicatorChart data={trackmanData['barrel_rank_pct']} 
                            realData={trackmanData['barrel_pct']} title={'barrel%'} type={type}/></div>
                            <div><IndicatorChart data={trackmanData['EFT_HIT_RANK_PCT']} 
                            realData={trackmanData['eft_hit_pct']} title={'solidContact%'} type={type}/></div>
                        </div>
                    </>
                    :
                    <div className="trackmanChart" style={{height:svgHeight*2+'px'}}>
                        <div style={style}>타석이 부족합니다</div>
                    </div>
                }
                
                <div className="trackmanTitle">{t('contact')}</div>
                {
                    trackmanData['tpa'] > allStarValue[trackmanData['allStarString']]['all'] ?
                    <div className="trackmanChart">
                        <div><IndicatorChart data={trackmanData['IN_zone_contact_rank_pct']} 
                        realData={trackmanData['IN_ZONE_CONTACT_PCT']} title={'inZoneContact%'} type={type}/></div>
                        <div><IndicatorChart data={trackmanData['so_rank_pct']} 
                        realData={trackmanData['so_pct']} title={'strikeOut%'} type={type}/></div>
                        <div><IndicatorChart data={trackmanData['line_drive_rank_pct']} 
                        realData={trackmanData['LINE_DRIVE_PCT']} title={'linedrive%'} type={type}/></div>
                    </div>
                    :
                    <div className="trackmanChart" style={{height:svgHeight+'px'}}>
                        <div style={style}>타석이 부족합니다</div>
                    </div>
                }
                <div className="trackmanTitle">{t('plateDiscipline')}</div>
                {
                    trackmanData['tpa'] > allStarValue[trackmanData['allStarString']]['all'] ?
                    <>
                        <div className="trackmanChart">
                            <div><IndicatorChart data={trackmanData['b_swing_rate_pct']} 
                            realData={trackmanData['b_swing_rate']} title={'chase%'} type={type}/></div>
                            <div><IndicatorChart data={trackmanData['bb_rank_pct']} 
                            realData={trackmanData['bb_pct']} title={'bb%'} type={type}/></div>
                            <div><IndicatorChart data={trackmanData['swing_rank_pct']} 
                            realData={trackmanData['swing_pct']} title={'whiff%'} type={type}/></div>
                        </div>
                        <div className="trackmanChart">
                            <div><IndicatorChart data={trackmanData['pitch_pa_rank_pct']} 
                            realData={trackmanData['pitch_pa_avg']} title={'pitches/pa'} type={type}/></div>
                            <div><IndicatorChart /></div>
                            <div><IndicatorChart /></div>
                        </div>
                    </>
                    :
                    <div className="trackmanChart" style={{height:svgHeight*2+'px'}}>
                        <div style={style}>타석이 부족합니다</div>
                    </div>
                }
                
                <div className="trackmanChart">
                    <TrackmanLegendChart />
                </div>
                </>
                :
                <>
                <div className="trackmanTitle">{t('overall')}</div>
                <div className="trackmanChart">
                    <div><IndicatorChart data={trackmanData['era_rank_pct']} 
                    realData={trackmanData['era']} title={'ERA'} type={type}/></div>
                    <div><IndicatorChart data={trackmanData['avg_rank_pct']} 
                    realData={trackmanData['avg']} title={'ba'} type={type}/></div>
                    <div><IndicatorChart data={trackmanData['ops_rank_pct']} 
                    realData={trackmanData['ops']} title={'OPS'} type={type}/></div>
                </div>
                <div className="trackmanChart">
                    <div><IndicatorChart data={trackmanData['whip_rank_pct']} 
                    realData={trackmanData['whip']} title={'WHIP'} type={type}/></div>
                    <div><IndicatorChart /></div>
                    <div><IndicatorChart /></div>
                </div>
                <div className="trackmanTitle">{t('contactQuality')}</div>
                <div className="trackmanChart">
                    <div><IndicatorChart data={trackmanData['exit_speed_rank_pct']} 
                    realData={trackmanData['exit_speed_avg']} title={'avgExitVelocity'} type={type}/></div>
                    <div><IndicatorChart data={trackmanData['strong_hit_rank_pct']} 
                    realData={trackmanData['strong_hit_pct']} title={'hardHitAllowed'} type={type}/></div>
                    <div><IndicatorChart data={trackmanData['ground_popup_rank_pct']} 
                    realData={trackmanData['ground_popup_rate']} title={'gbPopup%'} type={type}/></div>
                </div>
                <div className="trackmanChart">
                    <div><IndicatorChart data={trackmanData['xba_rank_pct']} 
                    realData={trackmanData['xba_avg']} title={'xba2'} type={type}/></div>
                    <div><IndicatorChart data={trackmanData['xslg_rank_pct']} 
                    realData={trackmanData['xslg_avg']} title={'xslg'} type={type}/></div>
                    <div><IndicatorChart /></div>
                </div>
                <div className="trackmanTitle">{t('stuff')}</div>
                <div className="trackmanChart">
                    <div><IndicatorChart data={trackmanData['fastball_speed_rank_pct']} 
                    realData={trackmanData['fastball_speed_avg']} title={'fastballVelocity'} type={type}/></div>
                    <div><IndicatorChart data={trackmanData['fastball_spinrate_rank_pct']} 
                    realData={trackmanData['fastball_spinrate_avg']} title={'fastballSpin'} type={type}/></div>
                    <div><IndicatorChart data={trackmanData['swing_rank_pct']} 
                    realData={trackmanData['swing_pct']} title={'whiff%'} type={type}/></div>
                </div>
                <div className="trackmanChart">
                    <div><IndicatorChart data={trackmanData['b_swing_rate_pct']} 
                    realData={trackmanData['b_swing_rate']} title={'chase%'} type={type}/></div>
                    <div><IndicatorChart data={trackmanData['k9_rank_pct']} 
                    realData={trackmanData['k9']} title={'K/9'} type={type}/></div>
                    <div><IndicatorChart data={trackmanData['so_rank_pct']} 
                    realData={trackmanData['so_pct']} title={'K%'} type={type}/></div>
                </div>
                <div className="trackmanTitle">{t('command')}</div>
                <div className="trackmanChart">
                    <div><IndicatorChart data={trackmanData['strike_rank_pct']} 
                    realData={trackmanData['strike_rate']} title={'strike%'} type={type}/></div>
                    <div><IndicatorChart data={trackmanData['bb9_rank_pct']} 
                    realData={trackmanData['bb9']} title={'BB/9'} type={type}/></div>
                    <div><IndicatorChart data={trackmanData['bb_rank_pct']} 
                    realData={trackmanData['bb_pct']} title={'BB%'} type={type}/></div>
                </div>
                <div className="trackmanChart">
                    <TrackmanLegendChart />
                </div>
                </>
            }
        </div>
        </>
    )
}

export default TrackmanChartMain;